module.exports = __webpack_public_path__ + "img/zzjg.b2be5ca0.jpg";